import React,{useState,useEffect, useContext} from "react";
import EstaSinLuzContextProvider, {
    EstaSinLuzContext,
    ACTIONS
  } from "../../context/EstaSinLuzContextProvider";
import NoLight from "../NoLight";
import Contingency from "../Contingency";
import FormContingency from "../FormContingency";
import {useModal} from "@clayui/modal";
import AlertModal from "../../../../common/components/AlertModal";
import {urlParams} from "../../../../common/utils/utilsFunc";
import Loading from "../../../../common/components/Loading";

const ControllerNoLight = ({props}) => {
    const [showAlertNoLight, setshowAlertNoLight] = useState(false);
    const [loadForm, setLoadForm] = useState(false);
    const [showAlertFormContingency, setShowAlertFormContingency] = useState(false);
    const [msgAlert, setmsgAlert] = useState(false);
    const [jsonForm, setJsonForm] = useState();
    const [state, dispatch] = useContext(EstaSinLuzContext);
    const [visibleModal, setVisibleModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const { observer, onClose } = useModal({
        onClose: () => setVisibleModal(false)
    });

    
    function handleClickNoLight(value){
        if(value) {
            setshowAlertNoLight(false);
            dispatch({
                payload: value,
                type: ACTIONS.SET_IDCTACTO,
                }
            )
        } else {
          dispatch({
              payload: "",
              type: ACTIONS.SET_IDCTACTO,
              }
          )
        }
    }
    
    function setCurrentPage(value){
        dispatch({
            payload: value,
            type: ACTIONS.SET_CURRENT_PAGE,
            }
        )

        if(value === 0){
            dispatch({
                payload: '',
                type: ACTIONS.SET_IDCTACTO,
                }
            )

            window.sessionStorage.setItem('state', JSON.stringify({
              idCtaCto: "",
              estaSinLuz: [],
              formCont: "",
              responseFormCont: {},
              currentPage: 0
            }));
        }
    }
    
    useEffect(() => {
      if(jsonForm) {
        dispatch({
            payload: jsonForm,
            type: ACTIONS.SET_FORMCONT,
            }
        )
        setLoadForm(true);
      }
    },[jsonForm]);

    useEffect(() => {
      if(state.responseFormCont) {
        setLoadForm(false);
          if(state?.responseFormCont?.code === 0) {  
            setmsgAlert(state?.responseFormCont?.message);
            setVisibleModal(true);
            setshowAlertNoLight(false);
            setCurrentPage(0);
          } else if(state?.responseFormCont?.code === 4){
            props.setGlobalAlert(state?.responseFormCont?.message,"info", true, "Información");
            setCurrentPage(0);
          } else{
              props.setGlobalAlert(state?.responseFormCont?.message,"warning", true, "Advertencia");
          }
      }
    },[state.responseFormCont])
    
    useEffect(() => {
        if(state.estaSinLuz.code === 0) {
            setLoading(false);
            if(state.currentPage === 0) {
              setCurrentPage(1);
            }
        } else if(state.estaSinLuz.error || state.estaSinLuz.code === 1) {
          setLoading(false);
            dispatch({
                payload: '',
                type: ACTIONS.SET_IDCTACTO,
                }
            )
            
            let msgAlert;
            
            if(state?.estaSinLuz?.error){
              msgAlert = "El servicio no está disponible actualmente, intente más tarde.";
            } else {
              msgAlert = state?.estaSinLuz?.mensaje;
            }

            props.setGlobalAlert(msgAlert,"warning", true, "Advertencia")
        }
    },[state.estaSinLuz]);


    useEffect(() => {
        if(state.idCtaCto && state?.responseFormCont?.status !== 200) {
            sessionStorage.setItem("state",JSON.stringify(state));
        }
    },[state]);

    useEffect(() => {
        const storedState = JSON.parse(sessionStorage.getItem("state"));

        if(storedState && storedState.currentPage !== 0) {
            setCurrentPage(storedState.currentPage);
            
            dispatch({
                payload: storedState.jsonForm,
                type: ACTIONS.SET_FORMCONT,
                }
            )

            dispatch({
                payload: storedState.idCtaCto,
                type: ACTIONS.SET_IDCTACTO,
                }
            )
            
            dispatch({
              payload: storedState.estaSinLuz,
              type: ACTIONS.SET_ESTA_SIN_LUZ,
            });
            
            dispatch({
              payload: storedState.responseFormCont,
              type: ACTIONS.SET_RESPONSE_FORMCONT,
            });
        }

        let params = new URLSearchParams(document.location.search);
        if(params.get("nrcli")) {
          setLoading(true);
          handleClickNoLight(params.get("nrcli"));
        }
        
    },[]);

    return (
      <>
          {state.currentPage === 0 && <NoLight 
                                          funcClick={handleClickNoLight} 
                                          showAlert={showAlertNoLight} 
                                          msgAlert={msgAlert}
                                          state={state} 
                                          setGlobalAlert={props.setGlobalAlert}
                                          api_key_recaptcha={props.api_key_recaptcha}
                                      />
          }
          {state.currentPage === 1 && <Contingency 
                                          state={state}
                                          funcClick={setCurrentPage} 
                                      />
          }
          {state.currentPage === 2 && <FormContingency 
                                          state={state} 
                                          funcClick={setCurrentPage} 
                                          setForm={setJsonForm} 
                                          showAlert={showAlertFormContingency} 
                                          msgAlert={msgAlert}
                                          showLoad={loadForm}
                                      />
          }


          {visibleModal && (
              <AlertModal 
                  titleModal="¡Contingencia creada con éxito!" 
                  msgModal={msgAlert} 
                  observer={observer} 
                  onClose={onClose} 
              />
          )}
          {loading && <Loading/>}
      </>
    );
};

const ControllerNoLightWithProvider = ({props}) => (
    <EstaSinLuzContextProvider>
      <ControllerNoLight props={props} />
    </EstaSinLuzContextProvider>
  );
export default ControllerNoLightWithProvider;
  